import { render, staticRenderFns } from "./ActivatePremiumPlanModal.vue?vue&type=template&id=11aa755d&"
import script from "./ActivatePremiumPlanModal.vue?vue&type=script&lang=js&"
export * from "./ActivatePremiumPlanModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports